// src/contexts/ConditionalAccessContext.tsx
import React, { createContext, useContext, ReactNode } from 'react';
import { useConditionalAccessPolicies } from './useConditionalAccessPolicies';
import { ConditionalAccessContextType } from '@Types/globalSetting';

const ConditionalAccessContext =
  createContext<ConditionalAccessContextType | null>(null);

export const ConditionalAccessProvider = ({
  children,
  dataSource,
  mipEnabled,
}: {
  children: ReactNode;
  dataSource: {
    cas?: boolean;
    v1?: boolean;
    mip?: boolean;
  };
  mipEnabled: boolean;
}) => {
  const policies = useConditionalAccessPolicies(dataSource, mipEnabled);
  const value = {
    ...policies,
    dataSource,
    mipEnabled,
  };

  return (
    <ConditionalAccessContext.Provider value={value}>
      {children}
    </ConditionalAccessContext.Provider>
  );
};

export const useConditionalAccess = () => {
  const context = useContext(ConditionalAccessContext);
  if (!context) {
    throw new Error(
      'useConditionalAccess must be used within ConditionalAccessProvider'
    );
  }
  return context;
};
